'use client'

import { useTheme } from 'next-themes'
import { FC } from 'react'

interface DarkModeSwitcherProps {}

const DarkModeSwitcher: FC<DarkModeSwitcherProps> = () => {
	const { theme, setTheme } = useTheme()

	return (
		<>
			<button
				aria-label={'Switch theme'}
				className="block relative transition-none expand-touch text-black dark:text-white hover:text-black/75 dark:hover:text-white/75 transition"
				onClick={() => {
					setTheme(theme === 'dark' ? 'light' : 'dark')
				}}
			>
				<svg className={`block w-4 h-4 text-current transition pointer-events-none`} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M8.44531 16C12.8636 16 16.4453 12.4183 16.4453 8C16.4453 3.58174 12.8636 0 8.44531 0C4.02705 0 0.445312 3.58174 0.445312 8C0.445312 12.4183 4.02705 16 8.44531 16ZM14.8036 8C14.8036 11.5116 11.9569 14.3583 8.44531 14.3583V1.6417C11.9569 1.6417 14.8036 4.48838 14.8036 8Z" fill="currentColor"/></svg>
			</button>
		</>
	)
}
export default DarkModeSwitcher
